import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const TABS = [
  { key: 'heart_rate', label: 'HR' },
  { key: 'oxygen_saturation', label: 'SpO2' },
  { key: 'systolic', label: 'SBP' },
  { key: 'respiratory_rate', label: 'RR' },
  { key: 'temperature', label: 'Temp' },
  { key: 'pain_level', label: 'Pain' },
];

const OutcomeDot = ({ cx, cy, payload }) => {
  if (cx == null || cy == null) return null;
  const fill = payload.outcome === 'improved' ? '#059669' : payload.outcome === 'worsened' ? '#dc2626' : '#64748b';
  return <circle cx={cx} cy={cy} r={3.5} fill={fill} stroke="#fff" strokeWidth={1} />;
};

const TrendTooltip = ({ active, payload, metric }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  const value = metric === 'systolic' ? `${d.systolic}/${d.diastolic}` : d[metric];
  return (
    <div className="bg-white border border-slate-200 rounded px-2 py-1 text-xs shadow">
      <p className="font-semibold text-slate-800">{d.label}</p>
      <p className="text-slate-700">{value}</p>
    </div>
  );
};

export const VitalsTrendChart = ({ patientId, history }) => {
  const [metric, setMetric] = useState('heart_rate');
  if (!history || history.length < 2) return null;

  return (
    <div className="mb-3 border border-slate-200 rounded-lg p-2" data-testid={`vitals-trend-${patientId}`} onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between mb-1">
        <p className="text-xs font-semibold text-slate-700">Vitals trend</p>
        <div className="flex gap-1" role="tablist">
          {TABS.map(({ key, label }) => (
            <button
              key={key}
              role="tab"
              aria-selected={metric === key}
              onClick={() => setMetric(key)}
              className={`px-2 py-0.5 text-[11px] rounded-full transition-colors ${metric === key ? 'bg-slate-800 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}
              data-testid={`trend-tab-${key}-${patientId}`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <div className="h-24">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={history} margin={{ top: 6, right: 8, left: -24, bottom: 0 }}>
            <XAxis dataKey="step" tick={{ fontSize: 10 }} tickLine={false} />
            <YAxis tick={{ fontSize: 10 }} tickLine={false} domain={['auto', 'auto']} />
            <Tooltip content={<TrendTooltip metric={metric} />} />
            <Line type="monotone" dataKey={metric} stroke="#0f172a" strokeWidth={2} dot={<OutcomeDot />} isAnimationActive />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="flex gap-3 mt-1 text-[11px] text-slate-600">
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-emerald-600" />Improved</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-red-600" />Worsened</span>
        <span className="ml-auto">Hover a point to see the action</span>
      </div>
    </div>
  );
};
